(function(){
var $=function(s){return document.querySelector(s)};
var dr=$('#drawer'),sc=$('#scrim');
function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML}
function money(c){return new Intl.NumberFormat(WW.lang,{style:'currency',currency:WW.cur,maximumFractionDigits:0}).format(c/100)}
function toast(m){var t=$('#toast');t.textContent=m;t.classList.add('show');setTimeout(function(){t.classList.remove('show')},1800)}
function openD(){dr.classList.add('open');sc.classList.add('on')}
function closeD(){dr.classList.remove('open');sc.classList.remove('on')}
function render(c){
  document.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=c.item_count});
  var h='';c.items.forEach(function(i,n){
    h+='<div class="ci"><div><b>'+esc(i.product_title)+'</b><br><small>'+esc(i.variant_title||'')+' · '+money(i.final_price)+'</small></div><div class="qty"><button data-line="'+(n+1)+'" data-q="'+(i.quantity-1)+'" aria-label="Less">−</button>'+i.quantity+'<button data-line="'+(n+1)+'" data-q="'+(i.quantity+1)+'" aria-label="More">+</button></div></div>';
  });
  $('#items').innerHTML=h||'<p class="empty">Your bag is empty. Go grab some slang!</p>';
  $('#sub').textContent=money(c.items_subtotal_price);
}
function refresh(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){render(c);return c})}
$('#cart-open').addEventListener('click',function(e){e.preventDefault();refresh();openD()});
$('#drawer-close').onclick=closeD;sc.onclick=closeD;
$('#items').addEventListener('click',function(e){var b=e.target.closest('button[data-line]');if(!b)return;
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+b.dataset.line,quantity:+b.dataset.q})}).then(function(r){return r.json()}).then(render)});
document.addEventListener('submit',function(e){var f=e.target;if(!f.action||f.action.indexOf('/cart/add')<0)return;
  e.preventDefault();
  fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw r;return r.json()})
  .then(refresh).then(function(){openD()}).catch(function(){toast('Could not add that item');});
});
refresh();
})();
